import {
  WhatsNew
} from '../models';

const mapRelationships = (obj, included) => {

  return Object.keys(obj).flatMap((key) => {

    const item = obj[key];

    return item.data.flatMap((rel) => {

      return included.flatMap((meta) => {

        if (rel.id === meta.id) {

          return {

            id: meta.id,
            type: meta.type,
            field: key,
            title: meta.attributes?.field_title,
            main_content: meta.attributes?.field_main_content?.value,
            created: meta.attributes?.created,
            summary: meta.attributes?.field_summary?.value,
            url: meta.attributes?.field_url,
            hasConnectuPage: meta.attributes?.field_hasconnectu,
            isZeroRated: meta.attributes?.field_is_zero_rated,
            vodaypayAppId: meta.attributes?.field_mini_app_appid,
            hideOnVodapay: meta.attributes?.field_hide_on_vodapay,
            ...mapTopicRelationships(meta?.relationships, included)?.[0]
          };
        }
        return [];
      });
    });
  });
};

const mapTopicRelationships = (obj, included) => {

  return Object.keys(obj).flatMap((key) => {

    const item = obj[key];

    return included.flatMap((meta) => {

      if (item?.data?.id === meta.id) {

        return {

          image: meta?.attributes?.uri?.url
        };
      }
      return [];
    });
  });
};

export const mapWhatsNewContent = (result) => {

  return result.data
    .map((item) => {

      return {

        attributes: {
          ...item.attributes,
          relationships: mapRelationships(item.relationships, result.included),
          id: item.id
        }
      };
    })
    .map((content) => {

      return new WhatsNew(content).mapToStandard();
    });
};
